// extracted by mini-css-extract-plugin
export default {"cardButtonContainer":"SuccessfulVerification_cardButtonContainer__39D9r","cardHeader":"SuccessfulVerification_cardHeader__KSOCg"};